import * as R from 'ramda'

export default R.pipe(R.map(R.pipe(R.toString, R.trim, R.toLower)), R.join('_'))
